/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Nohraclinic API
 * API do Nohraclinic. Sessão web por cookie httpOnly; mobile por bearer. As rotas sob /v1/auth/* que não estão aqui são servidas pelo handler do better-auth, restrito a uma allowlist (ver src/modules/auth/auth.mount.ts): sign-in/email, sign-out, get-session, verify-email, send-verification-email, request-password-reset e reset-password. O cadastro entra só por POST /v1/auth/registro.
 * OpenAPI spec version: 1.0.0
 */

/**
 * AGUARDANDO = esperando a aprovação no app SafeID. AUTORIZADA = falta só informar a senha para concluir. EXPIRADA = passou o prazo para aprovar no app, ou a aprovação venceu (7 dias) sem concluir; é preciso pedir de novo.
 */
export type MeAutorizacaoSafeIdSituacao = typeof MeAutorizacaoSafeIdSituacao[keyof typeof MeAutorizacaoSafeIdSituacao];


export const MeAutorizacaoSafeIdSituacao = {
  AGUARDANDO: 'AGUARDANDO',
  AUTORIZADA: 'AUTORIZADA',
  RECUSADA: 'RECUSADA',
  EXPIRADA: 'EXPIRADA',
} as const;
